// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-tactical-molle-hiking-travel-waist-bag-fishing-tackles-pack",
  "entries": [
    {
      "id": "24114773393598",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Tactical-MOLLE-Hiking-Travel-Waist-Bag-Fishing-Tackles-Pack-Seibertron-24114773393598.jpg?v=1769483268",
      "alt": "Seibertron Tactical MOLLE Hiking Travel Waist Bag Fishing Tackles Pack - SeibertronOutdoors522010206796"
    },
    {
      "id": "24114513084606",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Tactical-MOLLE-Hiking-Travel-Waist-Bag-Fishing-Tackles-Pack-Seibertron-24114513084606.jpg?v=1769483277",
      "alt": "Seibertron Tactical MOLLE Hiking Travel Waist Bag Fishing Tackles Pack - SeibertronOutdoors"
    }
  ],
  "variants": [
    {
      "id": "41897902440638",
      "title": "black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "black"
        }
      ],
      "values": [
        "black"
      ],
      "mediaId": "24114773393598"
    },
    {
      "id": "41956632264894",
      "title": "Khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Khaki"
        }
      ],
      "values": [
        "Khaki"
      ],
      "mediaId": "24114513084606"
    }
  ],
  "singleVariant": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var mediaIds = config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
})();
// END motorbikeBackpackGalleryRestore20260716
